import * as z from "zod";
import rawLibrary from "./default-library.json";

const DefaultLibraryBookSchema = z.object({
  reading_id: z.string().min(1),
  title: z.string().min(1),
  description: z.string().min(1),
  byline: z.string().min(1),
  imageURL: z.url({ protocol: /^https$/ }),
});

export type DefaultLibraryBook = z.infer<typeof DefaultLibraryBookSchema>;

export const FEATURED_BOOK_ID = "93d31a6e-ba6a-4dbc-9874-676028ba2212";

/** Sara's First Sentence Worksheet, offered when too few recommendations survive. */
export const STARTER_WORKSHEET_READING_ID =
  "d46b1229-eefc-4c79-90fa-31b9844f5fb3";

export const defaultLibraryBooks: readonly DefaultLibraryBook[] = z
  .array(DefaultLibraryBookSchema)
  .parse(rawLibrary);

const bookIndex = new Map<string, DefaultLibraryBook>(
  defaultLibraryBooks.map((b) => [b.reading_id, b]),
);

if (bookIndex.size !== defaultLibraryBooks.length) {
  throw new Error(
    `default-library.json contains duplicate reading_ids: expected ${defaultLibraryBooks.length} unique entries, got ${bookIndex.size}`,
  );
}

export function getBookById(id: string): DefaultLibraryBook | undefined {
  return bookIndex.get(id);
}

export function getBookTitleOrDefault(readingId: string): string {
  return bookIndex.get(readingId)?.title ?? "Unknown Book";
}

function requireBook(readingId: string): DefaultLibraryBook {
  const book = bookIndex.get(readingId);
  if (!book) throw new Error(`default-library.json is missing ${readingId}`);
  return book;
}

export const starterWorksheetBook: DefaultLibraryBook = requireBook(
  STARTER_WORKSHEET_READING_ID,
);
